import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MainContent.css";
import solarImage from "../../assets/solar.png";
import services from "../../assets/servicesdata";
import process1 from "../../assets/evaluation.png";
import process2 from "../../assets/prototype.png";
import process3 from "../../assets/coding.png";
import process4 from "../../assets/engineering.png";
import CompanyBanner from "../companybanner/companybanner";

function MainContent() {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleReadMore = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div>
      {/* About Us */}
      <CompanyBanner />

      {/* Our Process */}
      <section className="process-section">
        <div className="container">
          <p className="section-sub">\ Planning \</p>
          <h2 className="section-title">Our Process</h2>
          <div className="process-grid">
            <div className="process-card">
              <div className="process-icon-wrapper">
                <img
                  src={process1}
                  alt="Evaluation Icon"
                  className="process-icon"
                />
              </div>
              <h4>1. วิเคราะห์ความต้องการ</h4>
              <p>
                เริ่มต้นด้วยการพูดคุยและทำความเข้าใจความต้องการของลูกค้าในเชิงลึก
                เพื่อวางแนวทางที่ตรงเป้าหมาย
              </p>
            </div>
            <div className="process-card">
              <div className="process-icon-wrapper">
                <img
                  src={process2}
                  alt="Prototype Icon"
                  className="process-icon"
                />
              </div>
              <h4>2. ออกแบบและวางแผนระบบ</h4>
              <p>
                วางโครงสร้างระบบทั้งฮาร์ดแวร์และซอฟต์แวร์
                พร้อมวางแผนการดำเนินงานอย่างมีประสิทธิภาพ
              </p>
            </div>
            <div className="process-card">
              <div className="process-icon-wrapper">
                <img
                  src={process3}
                  alt="Coding Icon"
                  className="process-icon"
                />
              </div>
              <h4>3. พัฒนาและทดสอบระบบ</h4>
              <p>
                ดำเนินการพัฒนาระบบตามมาตรฐาน
                พร้อมทดสอบคุณภาพการทำงานในทุกขั้นตอน
              </p>
            </div>
            <div className="process-card">
              <div className="process-icon-wrapper">
                <img
                  src={process4}
                  alt="Engineering Icon"
                  className="process-icon"
                />
              </div>
              <h4>4. ติดตั้ง ฝึกอบรม และดูแลหลังการใช้งาน</h4>
              <p>
                ติดตั้งระบบพร้อมอบรมการใช้งาน
                และให้บริการดูแลรักษาอย่างต่อเนื่อง เพื่อความมั่นใจในระยะยาว
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Services */}
      <section className="services-section services-home">
        <div className="container services-container">
          <p className="section-sub">\ What We Do \</p>
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            {services.slice(0, 2).map((service, index) => (
              <div className="service-card" key={index}>
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-image"
                />
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">
                  {expandedIndex === index
                    ? service.description
                    : `${service.description.slice(0, 100)}...`}
                </p>
                <button
                  className="read-more-btn"
                  onClick={() => toggleReadMore(index)}
                >
                  {expandedIndex === index ? "Show Less" : "Read More"}
                </button>
              </div>
            ))}
          </div>
          <div className="more-btn-container">
            <Link to="/services" className="more-btn">
              More
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MainContent;
